import { Box, List, Typography } from "@mui/material";
import {
  ReasonCodeType,
  useGetReasonCodesQuery,
} from "../../../graphql/generated";
import { Warning } from "@mui/icons-material";
import theme from "../../../theme";
import { formatDateTime } from "../../../utils/labels/formatDateTime";

// Accept shipmentId as prop
interface ReasonCodeLogProps {
  shipmentId: string;
}

const getReasonCodeLabel = (type: ReasonCodeType) => {
  switch (type) {
    case ReasonCodeType.LoadedQuantityMismatch:
      return "Loaded Quantity Mismatch";
    case ReasonCodeType.DeliveredQuantityMismatch:
      return "Delivered Quantity Mismatch";
    case ReasonCodeType.Delay:
      return "Delay";
    case ReasonCodeType.Damage:
      return "Damage";
    case ReasonCodeType.Mechanical:
      return "Mechanical Issue";
    case ReasonCodeType.Traffic:
      return "Traffic";
    case ReasonCodeType.Weather:
      return "Weather";
    case ReasonCodeType.Customer:
      return "Customer Related";
    case ReasonCodeType.Other:
      return "Other";
    default:
      return type;
  }
};

const ReasonCodeLog = ({ shipmentId }: ReasonCodeLogProps) => {
  const { data, isLoading } = useGetReasonCodesQuery(
    {
      filter: { shipmentId },
    },
    { enabled: !!shipmentId }
  );

  const reasonCodes = data?.reasonCodes.data || [];

  if (isLoading) return null;
  if (!reasonCodes.length) return null;

  return (
    <Box>
      <List>
        {reasonCodes.map((reasonCode) => (
          <Box
            key={reasonCode._id}
            sx={{
              display: "flex",
              alignItems: "flex-start",
              gap: 1,
              mb: 1,
              p: 1,
              borderRadius: 1,
              backgroundColor: theme.palette.background.default,
            }}
          >
            <Warning
              fontSize="small"
              sx={{ color: theme.palette.warning.main, mt: 0.5 }}
            />
            <Box sx={{ flex: 1 }}>
              <Typography variant="body2" fontWeight={500}>
                {getReasonCodeLabel(reasonCode.type)}
              </Typography>
              {reasonCode.description && (
                <Typography variant="body2" color="text.secondary">
                  {reasonCode.description}
                </Typography>
              )}
              <Typography variant="caption" color="text.secondary">
                {formatDateTime(reasonCode.createdAt)}
              </Typography>
            </Box>
          </Box>
        ))}
      </List>
    </Box>
  );
};

export default ReasonCodeLog;
